"use client";

import { setPublicEnv } from "@smartbeemo/env/public";

export function RuntimeConfig({
  values,
}: {
  values: Readonly<Record<string, string>>;
}) {
  setPublicEnv(values);
  return null;
}
